import {IUserTicketPrize} from "../../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "../abstract/in-game-ticket-prize-types";
import {InGameTicketFreePlayVoucher3rdPartyPrize} from "../free-play-voucher-3rd-party-prize";
import {InGameTicketFreePlayVoucherPrize} from "../free-play-voucher-prize";
import {InGameTicketFreeSpins3rdPartyPrize} from "../free-spins-3rd-party-prize";
import {InGameTicketFreeSpinsPrize} from "../free-spins-prize";
import {GenericPrize} from "../generic-prize";
import {InGameTicketImmediateBonusPrize} from "../immediate-bonus-prize";
import {InGameTicketJackpotFreePlayVoucherPrize} from "../jackpot-free-play-voucher-prize";
import {InGameTicketJackpotFreeSpinsPrize} from "../jackpot-free-spins-prize";
import {InGameTicketNoWinPrize} from "../no-win-prize";
import {InGameTicketPendingBonusPrize} from "../pending-bonus-prize";

export class InGameTicketPrizeFactory {
    constructor(private services: IServiceFactoryExtended) {}
    
    createInGameTicketPrize(prizeRawData: IUserTicketPrize) {
        const prizeType = prizeRawData.prizeType;
        switch (prizeType) {
            // bonus money
            case InGameTicketPrizeType.ImmediateBonus:
                return new InGameTicketImmediateBonusPrize(prizeRawData, this.services);
            // free spins
            case InGameTicketPrizeType.FreePlayFreeSpins:
                return new InGameTicketFreeSpinsPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.ThirdPartyFreePlayFreeSpins:
                return new InGameTicketFreeSpins3rdPartyPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.JackpotFreeSpins:
                return new InGameTicketJackpotFreeSpinsPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.FreePlayVoucher:
                return new InGameTicketFreePlayVoucherPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.ThirdPartyFreePlayVoucher:
                return new InGameTicketFreePlayVoucher3rdPartyPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.JackpotFreePlayVoucher:
                return new InGameTicketJackpotFreePlayVoucherPrize(prizeRawData, this.services);
            // no win
            case InGameTicketPrizeType.NoWin:
                return new InGameTicketNoWinPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.PendingBonus:
                return new InGameTicketPendingBonusPrize(prizeRawData, this.services);
            // unsupported prizeTypes for casino
            case InGameTicketPrizeType.TournamentTicketBonus: // Poker offer only
            case InGameTicketPrizeType.FreeBet: // Sport offer only
            case InGameTicketPrizeType.SpectateFreeBet: // Sport offer only
                throw new Error("Prize: " + JSON.stringify(prizeRawData) + " is not supported for InGameChallenges");
            // case InGameTicketPrizeType.ClaimBonus:
            // case InGameTicketPrizeType.GoldToken:
            // case InGameTicketPrizeType.LoyaltyPoints:
            // case InGameTicketPrizeType.SICoverVoucher:
            // case InGameTicketPrizeType.SITix:
            // case InGameTicketPrizeType.IGCTicket:
            default:
                // throw new Error("Unknown prize type: " + prizeType);
                return new GenericPrize(prizeRawData, this.services);
        }
    }
}
